/*
 * @Author: your name
 * @Date: 2022-03-17 09:41:47
 * @LastEditTime: 2022-04-22 17:27:49
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /cscec-pms-app/src/api/user.js
 */
import {get, post} from "../http/httpType";
import {carManagementApiUrl} from './index';

export default {
    login: post("/ycloud-oauth/oauth/token", null, {
        useApi: 'user',
        stringify:true,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    }),

    getEmployeeInfo: get("/ycloud-organization/employees/by-user", null, {
        useApi: 'user',
        stringify:true,
    }),
    getUserInfo: get("/ycloud-oauth/users/info", null, {
        useApi: 'user',
        stringify:true,
    }),
    chiosePost: get("/ycloud-organization/employees/getPostParentName", null, {
        stringify:true,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
    }),
    changeCurrentPost: post("/ycloud-organization/employees/changeCurrentPost", null, {
        useApi: 'CurPost',
        // stringify:true,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
    }),
    getCurrentUserBranchCom3: post("/ycloud-organization/employees/queryOrgByCurrentUser", null, {
        useApi: 'CurPost',
        // stringify:true,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
    }),
    loginOut: post("/auth/logout", null, {
        useApi: 'user',
        stringify:true,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
    }),
    getMenu: get('/ycloud-authority/res/useridtree'),
    getBtnResources: get('/ycloud-authority/res/list-by-current-user'),
    
    // 找回密码发送验证码
    verifyCode: post('/ycloud-mbroker/verifyCode/send', null, {
      useApi: 'user',
      headers: {
          'Content-Type': 'application/json;charset=UTF-8'
      }
    }),
    // 开发平台重置用户密码
    updataUserManagePsw: post('/ycloud-user/users/pscode/forceModify', null, {
      useApi: 'user',
      headers: {
          'Content-Type': 'application/json;charset=UTF-8'
      }
    }),
    // 岗位隔离
    loginLog: post('/ycloud-organization/log/loginLog', null, {}),
   // 通用发送验证码
   sendVerifyCode: post('/ycloud-mbroker/verifyCode/sendVerifyCode', null, {
        useApi: 'user',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
    }),
    //更换账户
    updateAccount: post(`${carManagementApiUrl}/account/updateAccount`, null, {}),
    
    //校验手机号
    checkPhone: get(`${carManagementApiUrl}/account/checkPhone`),
    //校验验证码
    validate: post(`/ycloud-mbroker/verifyCode/validate`, null, {}),
   //校验密码
   checkPwd: post(`/ycloud-user/users/checkPwd`,null, {}),
};
